<app-modal #modal class="diary-config-modal">
  <div class="modal-header">
    <h2 class="modal-title">Update E-Diary Entry</h2>
    <button type="button" class="close" (click)="hide()" aria-label="Close">
      <span aria-hidden="true"><i class="far fa-times"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">

      <div class="field-flex-container">

        <div class="field-fasting">
          <label>Empty Stomach</label>
          <label class="checkbox">
            <input formControlName="fasting" id="fasting"
                   type="checkbox">
            <span></span>
          </label>
        </div>

        <div class="field-time-taken">
          <label>Time Taken</label>
          <div class="input-wrap type-time">
            <app-input-timepicker formControlName="timeTaken"></app-input-timepicker>
          </div>
        </div>

        <div class="field-pills-taken">
          <label>Pills Taken</label>
          <div class="input-wrap">
            <input type="number" formControlName="pillsTaken">
          </div>
        </div>

      </div>

    </form>
  </div>

  <div class="modal-footer">
    <button type="button" (click)="onSubmitForm()" [disabled]="form.invalid || isBusy" class="btn btn-primary">
      @if (isBusy) {
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      }
      @else {
        Update Diary Entry
      }
    </button>
  </div>
</app-modal>
